// extracted by mini-css-extract-plugin
module.exports = {"lawyer_filter_box_heading":"filter_lawyer_filter_box_heading__1T6Dv"};